class TradeshowSalesSummary {
	constructor() {
		this.sales = [];
	}

	addSalesForProduct(productType, count, sellingPrice) {
		this.sales.push(
			new TradeshowSale(productType, count, sellingPrice)
		);
	}

	toPlainObj() {
		return this.sales.map((tradeshowSale) => (tradeshowSale.toPlainObj()));
	}
}

class TradeshowSale {
	constructor(productType, count, sellingPrice) {
		this.productType = productType;
		this.count = count;
		this.sellingPrice = sellingPrice;
	}

	toPlainObj() {
		return {
			productType: this.productType,
			count: this.count,
			price: this.sellingPrice,
		};
	}
}


export default TradeshowSalesSummary;
